"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { Title } from "@/shared/components/title";
import { tp } from "@/shared/utils/typograf";
import { Subtitle } from "@/shared/components/subtitle";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from "@/shared/components/collapsible";
import Image from "next/image";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi
} from "@/shared/components/carousel";

const SLIDE_INDEX = { send: 0, receive: 1 } as const;

export const SendAndReceive = () => {
  const t = useTranslations("sendAndReceive");
  const [openItem, setOpenItem] = useState<"send" | "receive">("send");
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();

  useEffect(() => {
    carouselApi?.scrollTo(SLIDE_INDEX[openItem]);
  }, [carouselApi, openItem]);

  return (
    <div
      id="payments"
      className="section-container space-y-8 lg:space-y-13.5 scroll-mt-20 lg:scroll-mt-28"
    >
      <div className="space-y-4 text-center">
        <Title>{tp.execute(t("title"))}</Title>
        <Subtitle>{tp.execute(t("subtitle"))}</Subtitle>
      </div>
      {/*
        Сетка, а не две колонки флексом: на мобильном превью встаёт между
        заголовком и аккордеонами, на десктопе — во вторую колонку на обе строки.
      */}
      <div className="grid gap-8 lg:grid-cols-[minmax(0,33.75rem)_auto] lg:gap-x-0 lg:gap-y-8 lg:content-center">
        <h3 className="order-1 lg:order-none lg:col-start-1 lg:row-start-1 text-2xl leading-8 lg:text-[32px] lg:leading-10">
          {tp.execute(t("heading"))}
        </h3>
        <div className="order-3 lg:order-none lg:col-start-1 lg:row-start-2 space-y-8">
          <Collapsible
            open={openItem === "send"}
            onOpenChange={(open) => setOpenItem(open ? "send" : "receive")}
          >
            <CollapsibleTrigger>
              {tp.execute(t("send.trigger"))}
            </CollapsibleTrigger>
            <CollapsibleContent className="text-base lg:text-xl text-[#7B7B87] leading-6 lg:leading-6.5">
              <p>{tp.execute(t("send.paragraph1"))}</p>
              <p>{tp.execute(t("send.paragraph2"))}</p>
            </CollapsibleContent>
          </Collapsible>
          <Collapsible
            open={openItem === "receive"}
            onOpenChange={(open) => setOpenItem(open ? "receive" : "send")}
          >
            <CollapsibleTrigger>
              {tp.execute(t("receive.trigger"))}
            </CollapsibleTrigger>
            <CollapsibleContent className="text-base lg:text-xl text-[#7B7B87] leading-6 lg:leading-6.5">
              <p>{tp.execute(t("receive.paragraph1"))}</p>
            </CollapsibleContent>
          </Collapsible>
        </div>
        <div className="order-2 lg:order-none lg:col-start-2 lg:row-span-2 lg:self-center lg:justify-self-end lg:px-8 xl:px-25">
          <Carousel
            opts={{ watchDrag: false }}
            setApi={setCarouselApi}
            className="max-w-80.5 mx-auto"
          >
            <CarouselContent>
              <CarouselItem>
                <Image
                  src="/images/send-preview.jpg"
                  width={322}
                  height={514}
                  alt="Send Preview Image"
                  className="object-cover"
                  quality={100}
                />
              </CarouselItem>
              <CarouselItem>
                <Image
                  src="/images/receive-preview.jpg"
                  width={322}
                  height={514}
                  alt="Send Preview Image"
                  className="object-cover"
                  quality={100}
                />
              </CarouselItem>
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
